import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import TrainersPage from './pages/TrainersPage';
import MembershipPage from './pages/MembershipPage';
import RecoveryPage from './pages/RecoveryPage';
import BlogPost from './pages/BlogPost';
import ClassesPage from './pages/ClassesPage';
import ContactPage from './pages/ContactPage';
import PTCoursePage from './pages/PTCoursePage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FitnessPassportPage from './pages/FitnessPassportPage';
import CorporatePage from './pages/CorporatePage';
import ChallengePage from './pages/ChallengePage';
import TrainingAppPage from './pages/TrainingAppPage';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trainers" element={<TrainersPage />} />
        <Route path="/memberships" element={<MembershipPage />} />
        <Route path="/recovery" element={<RecoveryPage />} />
        <Route path="/classes" element={<ClassesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/pt-course" element={<PTCoursePage />} />
        <Route path="/blog/hot-cold-therapy" element={<BlogPost />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/fitness-passport" element={<FitnessPassportPage />} />
        <Route path="/corporate" element={<CorporatePage />} />
        <Route path="/challenge" element={<ChallengePage />} />
        <Route path="/training-app" element={<TrainingAppPage />} />
      </Routes>
    </Router>
  );
}

export default App;